export default __webpack_public_path__ + "static/media/emailicon.b5419437.svg";